<svg width="8" height="8" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="icon/close">
<path id="icon/close_2" d="M1 9L9 1M1 1L9 9" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
</g>
</svg>
